import { useBundleContext } from '@/src/packages/components/pages/Bundle/BundleContext';
import { BundleProduct } from '@/src/packages/components/pages/Bundle/BundleProduct';
import { FadeInView } from '@/src/packages/components/ui/Animations';
import { PageSection } from '@/src/packages/components/ui/PageSection';
import { PageSectionTitle } from '@/src/packages/components/ui/PageSection/PageSectionTitle';
import { Stack } from '@/src/packages/components/ui/Stack';

export const BundleProducts = () => {
  const {
    bundle: { variants },
  } = useBundleContext();

  return (
    <PageSection>
      <PageSectionTitle>What&apos;s included?</PageSectionTitle>

      <Stack className="space-y-gutter">
        {variants.map((variant) => {
          return (
            <FadeInView key={variant.id}>
              <BundleProduct productVariant={variant} />
            </FadeInView>
          );
        })}
      </Stack>
    </PageSection>
  );
};
